if (!window.CountdownTimer) {
  window.CountdownTimer = class CountdownTimer {
    constructor(element) {
      this.element = element;
      const [date, time] = element.dataset.endDate.split(' ');
      const [day, month, year] = date.split('-');
      const [hours, minutes] = time.split(':');
      this.endDate = new Date(year, month - 1, day, hours, minutes).getTime();
      this.daysEl = element.querySelector('.countdown-days');
      this.hoursEl = element.querySelector('.countdown-hours');
      this.minutesEl = element.querySelector('.countdown-minutes');
      this.secondsEl = element.querySelector('.countdown-seconds');

      this.daysLabelEl = element.querySelector('.countdown-label-days');
      this.hoursLabelEl = element.querySelector('.countdown-label-hours');
      this.minutesLabelEl = element.querySelector('.countdown-label-minutes');
      this.secondsLabelEl = element.querySelector('.countdown-label-seconds');

      this.daysText = element.dataset.daysText;
      this.daysTextShort = element.dataset.daysTextShort;
      this.hoursText = element.dataset.hoursText;
      this.hoursTextShort = element.dataset.hoursTextShort;
      this.minutesText = element.dataset.minutesText;
      this.minutesTextShort = element.dataset.minutesTextShort;
      this.secondsText = element.dataset.secondsText;
      this.secondsTextShort = element.dataset.secondsTextShort;

      this.unitFormat =
        window.innerWidth <= 768
          ? element.dataset.unitFormatMobile
          : element.dataset.unitFormatDesktop;
      this.hideSeconds =
        window.innerWidth <= 768
          ? element.dataset.hideSecondsMobile === 'true'
          : element.dataset.hideSecondsDesktop === 'true';

      this.updateTimer();
      setInterval(() => this.updateTimer(), 1000);
    }

    updateTimer() {
      const now = new Date().getTime();
      const distance = this.endDate - now;

      if (distance < 0) {
        this.element.style.display = 'none';
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.daysEl.textContent = days.toString().padStart(2, '0');
      this.hoursEl.textContent = hours.toString().padStart(2, '0');
      this.minutesEl.textContent = minutes.toString().padStart(2, '0');
      this.secondsEl.textContent = seconds.toString().padStart(2, '0');

      const isShort = this.unitFormat === 'short';
      this.daysLabelEl.textContent = isShort ? this.daysTextShort : this.daysText;
      this.hoursLabelEl.textContent = isShort ? this.hoursTextShort : this.hoursText;
      this.minutesLabelEl.textContent = isShort ? this.minutesTextShort : this.minutesText;
      this.secondsLabelEl.textContent = isShort ? this.secondsTextShort : this.secondsText;

      // Cacher les heures si = 0
      if (days === 0) {
        this.daysEl.parentElement.style.display = 'none';
      } else {
        this.daysEl.parentElement.style.display = '';
      }

      // Cacher les secondes si configuré
      if (this.hideSeconds) {
        this.secondsEl.parentElement.style.display = 'none';
      } else {
        this.secondsEl.parentElement.style.display = '';
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.countdown-bar__timer').forEach((timer) => {
      new window.CountdownTimer(timer);
    });
  });
}
